import type { Webhook, WebhookAuthType, WebhookEvent } from 'src/types/webhook'

import api from 'src/constants/api'

import useAccount from 'src/hooks/utils/useAccount'
import useMutation from 'src/hooks/utils/useMutation'

interface CreateWebhookRequest {
  name?: string
  url?: string
  enabled: boolean
  authType: WebhookAuthType
  authKey?: string
  authValue?: string
  events: WebhookEvent[]
}

const useCreateWebhookMutation = () => {
  const account = useAccount()

  return useMutation(
    async (webhookData: CreateWebhookRequest) => {
      const response = await api.post(`/webhooks/account/${account.id}/webhooks`, {
        ...webhookData,
        accountId: account.id
      })
      return response.data as Webhook
    },
    {
      mutationKey: ['createWebhook'],
      successMessage: 'Webhook created successfully',
      errorMessage: 'Failed to create webhook',
      queryKeysToInvalidate: [['getWebhooks', account.id]]
    }
  )
}

export default useCreateWebhookMutation
